import React from 'react';
import fetch from '../../fetch';
import utils from '../../../utils';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    // {type: 'selection'},
    {key:'$index', label: '序号' , width : 80},
    {key:'orgName', label: '部门名称',width : 120},
    {key:'loginName', label: '用户名' ,width : 120},
    {key:'realName', label: '专家姓名' ,width : 120},
    {key:'departmentPosition', label: '部门职务' ,width : 120},
    {key:'professionalDirection' , label : '专业方向' , width : 120},
    {key:'subjectDirection', label: '学科方向' ,width : 120},
    {key:'tel', label: '联系电话' ,width : 120},
    {key:'email', label: '邮箱' ,width : 120},
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('master/queryByRole?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const insert = (data)=>{
    return fetch.post('master/insert' , data);
}

export default {
    columns,
    onSelect,
    setRefresh,
    getSelection,
    querySearch ,
    insert 
}